'use strict';

export default [
  'AuthService',
  '$location',
  '$window',
  'ErrorHandler',
  class ResetPasswordController {
    constructor(authService, $location, $window, errorHandler) {
      this._authService = authService;
      this._$location = $location;
      this._$window = $window;
      this._errorHandler = errorHandler;

      this.token = this._$location.path().split('/')[2];
    }

    resetPassword(isValid) {
      if (isValid) {
        this.submitState = 'loading';
        this._authService.resetPassword(this.password, this.token)
          .then((res) => this.resetPasswordSuccess(res))
          .catch((err) => this.resetPasswordError(err));
      }
    }

    resetPasswordSuccess(res) {
      this.submitState = 'success';
      this._$window.location.href = '/';
    }

    resetPasswordError(err) {
      this.submitState = 'error';
      this._errorHandler.throwError('Reset Password Error', err && err.data && err.data.message ? err.data.message : 'Error resetting password. Please contact support.')
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/reset-password/reset-password.ctrl.js